var React = require('react');

function YoutubePlay (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.5","cx":"31","cy":"31","r":"31","fill":"white","key":0}),React.createElement("circle",{"cx":"31","cy":"31","r":"24","fill":"white","key":1}),React.createElement("path",{"d":"M39 31L27 37.9282L27 24.0718L39 31Z","fill":"#FCB34E","key":2})]);
}

YoutubePlay.defaultProps = {"width":"62","height":"62","viewBox":"0 0 62 62","fill":"none"};

module.exports = YoutubePlay;

YoutubePlay.default = YoutubePlay;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/youtube-play.svg
// module id = 981
// module chunks = 0